import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import { Route, Switch } from 'react-router-dom';
import { Chat, Markets } from '../';
import { Roadmap } from '../../components';

const Main = props => {
  const { currentUser } = props;
  const isLoggedIn = currentUser !== null;
  const columns = isLoggedIn ? 2 : 1;
  const widths = columns > 1 ? [12, 4] : [16];
  return (
    <Grid padded>
      <Grid.Row columns={columns}>
        <Grid.Column width={widths[0]}>
          <Switch>
            <Route exact path="/roadmap" component={Roadmap} />
            <Route path="/:exchange" component={Markets} />
          </Switch>
        </Grid.Column>
        {isLoggedIn &&
          columns === 2 && (
            <Grid.Column width={widths[1]}>
              <Chat />
            </Grid.Column>
          )}
      </Grid.Row>
    </Grid>
  );
};

Main.propTypes = {
  currentUser: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser,
  };
}

export default connect(mapStateToProps)(Main);



// WEBPACK FOOTER //
// ./src/containers/Main/index.jsx